import React from 'react'
import { StandardColumn } from '../../../../components/StandardPage'
import { ServicesObjectType } from '../../../../contexts/ServicesContext'
import { getOpCurrentStageLabel, getOpStatusText } from '../utils'
import { stripHtml } from '../../../../utils/stripHtml'

export const productionOrdersScreenKey = 'production_order'

const asRecord = (service: ServicesObjectType) => service as unknown as Record<string, any>

export const buildProductionOrderColumns = (): StandardColumn<ServicesObjectType>[] => [
  {
    id: 'codeOfOP',
    label: 'OP',
    accessor: (service) => asRecord(service).codeOfOP || '',
    cell: (service) => asRecord(service).codeOfOP || 'N/A',
  },
  {
    id: 'item',
    label: 'Item',
    accessor: (service) =>
      asRecord(service).OrderItem?.Stock?.Code?.code ||
      stripHtml(asRecord(service).OrderItem?.ploomesProductName) ||
      '',
    cell: (service) =>
      asRecord(service).OrderItem?.Stock?.Code?.code ||
      stripHtml(asRecord(service).OrderItem?.ploomesProductName) ||
      'N/A',
  },
  {
    id: 'order',
    label: 'Pedido',
    accessor: (service) =>
      asRecord(service).OrderItem?.Order?.saleNumberPloomes || asRecord(service).OrderItem?.Order?.id || 0,
    cell: (service) =>
      asRecord(service).OrderItem?.Order?.saleNumberPloomes || asRecord(service).OrderItem?.Order?.id || 'N/A',
  },
  {
    id: 'weight',
    label: 'Peso',
    accessor: (service) => asRecord(service).OrderItem?.weight ?? 0,
    cell: (service) => asRecord(service).OrderItem?.weight ?? 'N/A',
  },
  {
    id: 'status',
    label: 'Status',
    accessor: (service) => getOpStatusText(asRecord(service).status),
    cell: (service) => getOpStatusText(asRecord(service).status),
  },
  {
    id: 'currentStage',
    label: 'Etapa atual',
    accessor: (service) => getOpCurrentStageLabel(asRecord(service).Service_Stage || []),
    cell: (service) => getOpCurrentStageLabel(asRecord(service).Service_Stage || []),
  },
  {
    id: 'client',
    label: 'Cliente',
    accessor: (service) =>
      asRecord(service).OrderItem?.Order?.Company_Order_clientIdToCompany?.companyName || '',
    cell: (service) =>
      asRecord(service).OrderItem?.Order?.Company_Order_clientIdToCompany?.companyName
        ?.split(' ')
        .slice(0, 2)
        .join(' ') || 'Cliente não informado',
  },
]
